import { Injectable } from '@angular/core';
import { RestService } from '../../core/core/rest.service';


@Injectable()
export class DictionaryRest {
    constructor(private http: RestService) { }

    public addDictionary(dictionary) {
        return this.http.post('api/dictionary/add', dictionary);
    }

    public saveDictionary(dictionary) {
        return this.http.post('api/dictionary/edit', dictionary);
    }

    public getDictionary(dictionaryId) {
        return this.http.get(`api/dictionary/${dictionaryId}`);
    }

    public getDictionaryName(dictionaryId) {
        return this.http.get(`api/dictionary/name/${dictionaryId}`);
    }

    public getDictionaries(dictionaryType) {
      return this.http.get(`api/dictionaries/${dictionaryType}`);
    }

    public deleteDictionary(dictionaryId) {
        return this.http.post('api/dictionary/delete', dictionaryId);
    }
}
